import React from "react";

import "./styles.scss"
import ChatHistoryMain from "../../esg-chat/chat-history";

const CompanyHistory = () => {
    return (
        <>
            <ChatHistoryMain model="Company" searchBy="Public" />
        </>
    )
}

export default CompanyHistory